<p>
  activate-account works!
</p>
